import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { getAllRegions } from '../../../../../services/userServices/UserInfoService';
import Region from '../../../../../interfaces/identity/Region';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../firebase/AuthProvider';
import { getWaivers } from '../../../../../services/participantServices/ParticipantService';
import Waiver from '../../../../../interfaces/participant/Waiver';
import { EmergencySurveyTriggerRequestDto } from '../../../../../interfaces/survey/SurveyDtos';
import { steps } from 'framer-motion';
import { TriggerEMERGENCY_SURVEY_1Async, TriggerEMERGENCY_SURVEY_3Async } from '../../../../../services/surveyService/SurveyService';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../loader/Loader';
import backarrowbtn from '../../../../../assets/images/backarrowbtn.svg'

const defaultFormData: EmergencySurveyTriggerRequestDto = {
    regionIds: [],
    waiverTypeIds: [],
    customMessage: '',
    triggeredBy: "",
    emergencyType: '',
    emergencyDetail: ''
}

const TriggerEmergencySurveyOneAndThree = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { surveyname } = useParams();
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [regionList, setRegionList] = useState<Region[]>([]);
    const [waiverList, setWaiverList] = useState<Waiver[]>([]);
    const [authToken, setAuthtoken] = useState<string>();
    const [formData, setFormData] = useState<EmergencySurveyTriggerRequestDto>(defaultFormData);
    const [otherType, setOtherType] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                setAuthtoken(token);
                GetAllRegions(token);
                GetAllWaiver(token);
            }
        })
    }, [])

    const GetAllRegions = (token: string) => {
        getAllRegions(token).then((res) => {
            if (res.success) {
                setRegionList(res.data);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }
    const GetAllWaiver = (token: string) => {
        getWaivers(token).then((res) => {
            if (res.success) {
                setWaiverList(res.data);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }

    const handleSubmitForm = () => {
        console.log("Data form : ", formData);

        if (!currentUser || !authToken) return;

        const payload = formData;
        payload.triggeredBy = currentUser.uid;
        if (payload.emergencyType == 'Other') {
            payload.emergencyType = otherType;
        }

        if (surveyname == 'EMERGENCY_SURVEY_1') {
            setLoading(true);
            TriggerEMERGENCY_SURVEY_1Async(authToken, payload).then((res) => {
                if (res.success) {
                    toast.success("Survey Triggered Successfully");
                    navigate('/dashboard/owner/participants');
                } else {
                    toast.error(res.message);
                }
            }).catch((err) => {
                toast.error(err.message);
            }).finally(() => {
                setLoading(false);
            })
        } else if (surveyname == 'EMERGENCY_SURVEY_3') {
            setLoading(true);
            TriggerEMERGENCY_SURVEY_3Async(authToken, payload).then((res) => {
                if (res.success) {
                    toast.success("Survey Triggered Successfully");
                    navigate('/dashboard/owner/participants');
                } else {
                    toast.error(res.message);
                }
            }).catch((err) => {
                toast.error(err.message);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const handleClickNext = () => {
        if (!checkValidation()) {
            toast.warning("All Fields are Required");
            return;
        }
        if (currentStep < 4) {
            setCurrentStep(currentStep + 1);
        } else {

        }
    };

    const handleClickPrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRegionChange = (regionId: string, checked: boolean) => {
        setFormData(prev => ({
            ...prev,
            regionIds: checked
                ? [...prev.regionIds, regionId]
                : prev.regionIds.filter(id => id !== regionId)
        }))
    };
    const handleWaiverChange = (waiverId: string, checked: boolean) => {
        setFormData(prev => ({
            ...prev,
            waiverTypeIds: checked
                ? [...prev.waiverTypeIds, waiverId]
                : prev.waiverTypeIds.filter(id => id !== waiverId)
        }))
    };

    const checkValidation = (): boolean => {
        switch (currentStep) {
            case 1:
                if (!formData.emergencyType || !formData.emergencyDetail || (formData.emergencyType === 'Other' && !otherType)) return false;
                break;
            case 2:
                if (formData.regionIds.length === 0) return false;
                break;
            case 3:
                if (formData.waiverTypeIds.length === 0) return false;
                break;
            default:
                break;
        }

        return true;
    }

    return (
        <>
            {loading && <Loader />}
            <div className="employee_surveys_container">
                <div className="top">
                    <div className="top_bar_tittle">
                        <h2> <Link to={"/dashboard/owner/participants"}><img src={backarrowbtn} alt="backarrowbtn" /> </Link> Initiate {surveyname}</h2>
                    </div>
                </div>
                <Form>

                    {currentStep === 1 && <div className="common_card">
                        <div className="top top_bar_flx">
                            <div className="top_bar_tittle">
                                <h2>Employee Surveys</h2>
                            </div>
                            <div className="step_form_count">
                                <p><span>Step 1 </span>/ 4</p>
                            </div>
                        </div>
                        <div className="step_form_flx">
                            <Form.Group className="step_form_grp" controlId="question1">
                                <Form.Label className='required-label'>1. Emergency Type</Form.Label>
                                <div className="check_list_flx">
                                    {["Natural Disaster", "Public Health Emergency", "Evacuation/Relocation", "Loss of Provider or Staffing Crisis", "Other"].map(option => (
                                        <Form.Check
                                            key={option}
                                            type="radio"
                                            id={`question1-${option}`}
                                            name="emergencyType"
                                            label={option}
                                            value={option}
                                            className='check_with_label_two'
                                            checked={formData.emergencyType == option}
                                            onChange={handleChange}
                                        />
                                    ))}
                                </div>

                                {formData.emergencyType == "Other" &&
                                    <>
                                        <Form.Label className='required-label'>Enter Other Type</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Other Type"
                                            name='emergencyDetail'
                                            value={otherType}
                                            onChange={(e) => setOtherType(e.target.value)}
                                        />
                                    </>
                                }

                            </Form.Group>

                            {formData.emergencyType && <Form.Group className="step_form_grp" controlId="question1-1">
                                <Form.Label className='required-label'>Emergency Detail</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Details"
                                    name='emergencyDetail'
                                    value={formData.emergencyDetail}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            }
                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button variant="primary" onClick={handleClickNext}>Next</Button>
                        </div>
                    </div>}

                    {currentStep === 2 && <div className="common_card">
                        <div className="top top_bar_flx">
                            <div className="top_bar_tittle">
                                <h2>Employee Surveys</h2>
                            </div>
                            <div className="step_form_count">
                                <p><span>Step 2 </span>/ 4</p>
                            </div>
                        </div>
                        <div className="step_form_flx">
                            <Form.Group className="step_form_grp" controlId="question1">
                                <Form.Label className='required-label'>2. Regions Affected</Form.Label>
                                <div className="check_list_flx">
                                    {regionList.map((option) => (
                                        <Form.Check
                                            key={option.regionId}
                                            type="checkbox"
                                            id={`step3-Q3-${option.regionId}`}
                                            name="step3-Q3"
                                            label={option.regionName}
                                            className='check_with_label_two'
                                            checked={formData.regionIds.includes(option.regionId.toString())}
                                            onChange={(e) => handleRegionChange(option.regionId.toString(), e.target.checked)}
                                        />
                                    ))}
                                </div>
                            </Form.Group>

                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                            <Button variant="primary" onClick={handleClickNext}>Next</Button>
                        </div>
                    </div>}

                    {currentStep === 3 && <div className="common_card">
                        <div className="top top_bar_flx">
                            <div className="top_bar_tittle">
                                <h2>Employee Surveys</h2>
                            </div>
                            <div className="step_form_count">
                                <p><span>Step 3 </span>/ 4</p>
                            </div>
                        </div>
                        <div className="step_form_flx">
                            <Form.Group className="step_form_grp" controlId="question1">
                                <Form.Label className='required-label'>3. Waiver Types</Form.Label>
                                <div className="check_list_flx">
                                    {waiverList.map((option) => (
                                        <Form.Check
                                            key={option.id}
                                            type="checkbox"
                                            id={`step3-Q3-${option.id}`}
                                            name="step3-Q3"
                                            label={option.waiverName}
                                            className='check_with_label_two'
                                            checked={formData.waiverTypeIds.includes(option.id.toString())}
                                            onChange={(e) => handleWaiverChange(option.id.toString(), e.target.checked)}
                                        />
                                    ))}
                                </div>
                            </Form.Group>

                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                            <Button variant="primary" onClick={handleClickNext}>Next</Button>
                        </div>
                    </div>}

                    {currentStep === 4 && <div className="common_card">
                        <div className="top top_bar_flx">
                            <div className="top_bar_tittle">
                                <h2>Employee Surveys</h2>
                            </div>
                            <div className="step_form_count">
                                <p><span>Step 4 </span>/ 4</p>
                            </div>
                        </div>
                        <div className="step_form_flx">
                            <Form.Group className="step_form_grp" controlId="customMessage">
                                <Form.Label>4. Custom Message (Optional)</Form.Label>
                                <div className="check_list_flx">
                                    <Form.Control
                                        as="textarea"
                                        id="step3-Q3-textarea"
                                        name="customMessage"
                                        className="check_with_label_two"
                                        rows={4} // You can adjust rows for height
                                        placeholder="Enter your message here..."
                                        value={formData.customMessage}
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>

                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                            <Button variant="primary" onClick={handleSubmitForm}>Launch Survey</Button>
                        </div>
                    </div>}
                </Form>
            </div>

        </>
    )
}

export default TriggerEmergencySurveyOneAndThree